export const SOURCE_NDC_X = 'NDC-X' as const;
export const SOURCE_NDC = 'NDC' as const;

export type SourceType = typeof SOURCE_NDC_X | typeof SOURCE_NDC;
